export default "__VITE_ASSET__de2eff19__"